/* eslint-disable react/no-multi-comp, jsx-a11y/iframe-has-title */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import screen from 'superior-mq';
import { bp, hover } from 'Styles/helpers';
import ReactModalAdapter from '../../react-modal-adapter';
import UnstyledButton from '../../unstyled-button';

const YouTubeModal = ({ id, onRequestClose, ...props }) => (
  <StyledModal
    onRequestClose={onRequestClose}
    {...props}
  >
    <VideoWrap>

      <iframe
        width="160"
        height="90"
        src={`https://www.youtube.com/embed/${id}?rel=0`}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />

    </VideoWrap>

    <CloseButton
      onClick={onRequestClose}
      aria-label="Close modal"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" width="56" height="56">
        <circle cx="28" cy="28" r="27" fill="none" stroke="#d9e4e8" strokeWidth="2" />
        <path fill="#fff" d="M34.72 21.99l-.71-.71L28 27.29l-6.01-6.01-.71.71L27.29 28l-6.01 6.01.71.71L28 28.71l6.01 6.01.71-.71L28.71 28l6.01-6.01z" />
      </svg>
    </CloseButton>

  </StyledModal>
);

const StyledModal = styled(ReactModalAdapter).attrs({
  overlayClassName: 'Overlay',
  modalClassName: 'Modal',
})`
  .Overlay {
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .8);
    padding: 200px;

    ${screen.below(bp.tablet, `
      padding: 100px;
    `)}

    ${screen.below(bp.mobile, `
      padding: 40px;
    `)}
  }

  .Modal {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    border: 0;
    outline: none;
  }
`;

const VideoWrap = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;

  iframe {
    width: 100%;
    height: 100%;
  }
`;

const CloseButton = styled(UnstyledButton)`
  position: fixed;
  top: 20px;
  right: 20px;
  outline: none;

  circle { transition: .4s stroke ease-in; }

  svg { display: block; }

  ${props => hover(`
    circle { stroke: ${props.theme.blue}}
  `)}

  &:focus circle { stroke: ${props => props.theme.blue}; }

`;

YouTubeModal.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onRequestClose: PropTypes.func.isRequired,
};

export default YouTubeModal;
